module.exports = __webpack_public_path__ + "static/media/pet_2.09596092.png";